import './CheckboxesInput.less';
import React, {useRef} from 'react';
import Icon from "../../../../bootstrap/components/icon/Icon";
import DraftView from '../../../components/draft-view/DraftView';
import {jsonToObject} from '../../../../bootstrap/utils/json';
import {HORIZONTAL_DISPLAY_TYPE, useOptionDisplayType} from '../hooks/useOptionDisplayType';


export default function CheckboxesInput({anchorRef, content, value, onChange, options, readOnly}) {
    const optionListRef = useRef(null);

    const displayType = useOptionDisplayType({
        anchorRef,
        optionListRef,
    });

    const isHorizontalDisplayType = displayType === HORIZONTAL_DISPLAY_TYPE;
    
    const contentState = jsonToObject(content);

    return <div className={'checkboxes-input' + (readOnly ? ' read-only' : '')}>
        {
            contentState !== null &&
            <div className="content">
                <DraftView contentState={contentState}/>
            </div>
        }
        <ul
            ref={optionListRef}
            className={
                displayType === null ? '' :
                isHorizontalDisplayType ? ' horizontal-view' : ' vertical-view'
            }
            style={{
                gridTemplateColumns: isHorizontalDisplayType ? `repeat(${options.length}, 1fr)` : ''
            }}
        >
            {
                options.map((opt, index) => {
                    const selected = value.includes(opt.value)

                    return <li
                        key={index}
                        onClick={readOnly ? undefined : () => onChange(
                            selected
                                ? value.filter(v => v !== opt.value)
                                : value.concat(opt.value)
                        )}
                        className={selected ? 'selected' : ''}
                    >
                        {
                            selected
                                ? <Icon name="checkbox-checked"/>
                                : <Icon name="checkbox-blank"/>
                        }
                        <span className="text">{opt.text || opt.value}</span>
                    </li>;
                })
            }
        </ul>
    </div>;
}
